module.exports = __webpack_public_path__ + "img/profitBlue.583e4c5d.png";